const _ = require('lodash')
const {parseRoutePageDataResponse} = require('./parseRoutePageDataResponse')

const handlRoutePageDataResponse = (setNavigationInfos, currentNavInfo, routeResponse) => {
    const {pageId, tpaInnerRoute, pageData: routerData, pageHeadData} = parseRoutePageDataResponse(routeResponse)
    setNavigationInfos({
        primaryPage: {
            ...currentNavInfo,
            pageId,
            title: _.get(pageHeadData, 'title', ''),
            tpaInnerRoute,
            routerData
        }
    })
}

module.exports = {
    handleError: e => console.log('\n\n\n\n********\n\n\n', 'getRoutePageData request failed:', '\n', e, '\n\n\n********\n\n\n\n'), // TODO yotam - 
    handlRoutePageDataResponse
}